// import React from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";

// // Register chart components and the data labels plugin
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// interface LinkedInStats {
//   population_18_24: any;
//   percentage_18_24: any;
//   population_25_34: any;
//   percentage_25_34: any;
//   population_35_54: any;
//   percentage_35_54: any;
//   population_55_plus: any;
//   percentage_55_plus: any;
// }

// interface LinkedInUserDistributionChartProps {
//   stats: LinkedInStats;
// }

// const LinkedInUserDistributionChart: React.FC<LinkedInUserDistributionChartProps> = ({
//   stats,
// }) => {
//   const data = {
//     labels: ["18-24", "25-34", "35-54", "55+"],
//     datasets: [
//       {
//         label: "LinkedIn Users (%)",
//         data: [
//           stats?.percentage_18_24,
//           stats?.percentage_25_34,
//           stats?.percentage_35_54,
//           stats?.percentage_55_plus,
//         ],
//         backgroundColor: (context: any) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) {
//             return null; // Important for responsive charts
//           }

//           const gradient = ctx.createLinearGradient(
//             0,
//             chartArea.bottom,
//             0,
//             chartArea.top
//           );
//           gradient.addColorStop(0, "#0070f0"); // Start color
//           gradient.addColorStop(1, "#67abf9"); // End color

//           return gradient;
//         },
//         barThickness: 40, // Set the bar thickness

//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "top" as const,
//       },
//       title: {
//         display: true,
//         text: `LinkedIn User Distribution`,
//       },
//       datalabels: {
//         color: "black",
//         anchor: "end" as const,
//         align: "end" as const,
//         formatter: (value: number) => `${value}%`,
//       },
//     },
//     scales: {
//       y: {
//         type: "linear" as const,
//         beginAtZero: true,
//         ticks: {
//           callback: (tickValue: string | number) => `${tickValue}%`,
//         },
//       },
//     },
//   };

//   return <Bar data={data} options={options} />;
// };

// export default LinkedInUserDistributionChart;

import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register chart components and the data labels plugin
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

interface LinkedInStats {
  population_18_24: number;
  percentage_18_24: number;
  population_25_34: number;
  percentage_25_34: number;
  population_35_54: number;
  percentage_35_54: number;
  population_55_plus: number;
  percentage_55_plus: number;
  total: number; // Add total to the stats interface
}

interface LinkedInUserDistributionChartProps {
  stats: LinkedInStats;
}

const LinkedInUserDistributionChart: React.FC<LinkedInUserDistributionChartProps> = ({
  stats,
}) => {
  const data = {
    labels: ["18-24", "25-34", "35-54", "55+"],
    datasets: [
      {
        label: "LinkedIn Users (%)",
        data: [
          stats?.percentage_18_24,
          stats?.percentage_25_34,
          stats?.percentage_35_54,
          stats?.percentage_55_plus,
        ],
        backgroundColor: (context: any) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return null; // Important for responsive charts
          }

          const gradient = ctx.createLinearGradient(
            0,
            chartArea.bottom,
            0,
            chartArea.top
          );
          gradient.addColorStop(0, "#0070f0"); // Start color
          gradient.addColorStop(1, "#67abf9"); // End color

          return gradient;
        },
        barThickness: 40, // Set the bar thickness
        borderRadius: 4, // Makes the bar corners rounded
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
      datalabels: {
        color: "black",
        anchor: "end" as const,
        align: "end" as const,
        formatter: (value: number) => `${value}%`,
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem: any) => {
            const index = tooltipItem.dataIndex;
            const percentage = tooltipItem.dataset.data[index];
            let totalPopulation = 0;
  
            // Get total population based on age group
            switch (index) {
              case 0:
                totalPopulation = stats.population_18_24;
                break;
              case 1:
                totalPopulation = stats.population_25_34;
                break;
              case 2:
                totalPopulation = stats.population_35_54;
                break;
              case 3:
                totalPopulation = stats.population_55_plus;
                break;
              default:
                break;
            }
  
            return `Age ${tooltipItem.label}: ${percentage}% (${totalPopulation} users)`;
          },
        },
      },
    },
    scales: {
      y: {
        display: false,
        type: "linear" as const,
        beginAtZero: true,
        min: 0, // Ensures the y-axis starts at 0
  
        // Calculate max for y-axis with additional range
        max: (() => {
          const maxValue = Math.max(...data.datasets.flatMap((dataset) => dataset.data));
          const upperLimit = Math.ceil(maxValue / 10) * 10; // Round up to the nearest 20
          return upperLimit + 10; // Add an extra range
        })(),
  
        ticks: {
          callback: (tickValue: string | number) => `${tickValue}%`,
        },
        grid: {
          display: false, // Removes grid lines for the y-axis
        },
        // Optional: Add a title to the y-axis
      },
      x: {
        grid: {
          display: false, // Removes grid lines for the x-axis
        },
      },
    },
  };
  

  return <Bar data={data} options={options} />;
};

export default LinkedInUserDistributionChart;
